// extracted by mini-css-extract-plugin
module.exports = {"container":"PostSearcherResultsItem_container__9focE"};